export default __webpack_public_path__ + "static/media/play_connect.35ddf55e.svg";